import { render, staticRenderFns } from "./detail_modal.vue?vue&type=template&id=b1203512&scoped=true"
import script from "./detail_modal.vue?vue&type=script&lang=js"
export * from "./detail_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1203512",
  null
  
)

export default component.exports